import { MonoTypeOperatorFunction, shareReplay } from 'rxjs';

/**
 * This is just a wrapper to avoid having to pass a config object to every shareReplay
 * @param count <Optional> the number of entries to buffer. defaults to 1
 */
export const shareLast = <T>(count = 1): MonoTypeOperatorFunction<T> =>
  shareReplay({ bufferSize: count, refCount: true });
